import {
  Box,
  Tab,
  Grid,
  Typography,
  Snackbar,
  Divider,
  Alert,
  Rating,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import { TabPanel, TabContext, TabList } from "@mui/lab";
import Carousel from "react-multi-carousel";
import { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CenterMap from "./CenterMap";
import get_cid from "../lib/get_cid";
import get_token from "../lib/get_token";
import axios from "axios";
import Swal from "sweetalert2";
import { loginState, configState, image_version } from "../lib/State";
import ImageGallery from "react-image-gallery";
import get_center from "../lib/get_center";
import moment from "moment";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const teacherInfo = createTheme({
  components: {
    MuiTabPanel: {
      styleOverrides: {
        root: {
          paddingTop: "0px",
        },
      },
    },
  },
});

function CenterInfo(props) {
  const { openCenter } = props;
  const [value, setValue] = useState("1");
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const cid = get_cid();
  const center = get_center(cid);
  const [login, setLogin] = useState(loginState);
  const token = get_token();
  const [resumes, setResumes] = useState([]);
  const [educations, setEducations] = useState([]);
  const [careers, setCareers] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [ratings, setRatings] = useState([]);
  const [teachers, setTeachers] = useState([]);

  // 카테고리별 별점 평균
  // const load_average = async () => {
  //     let result = await axios.post(configState.api + '/gympass/rating_all', {
  //         token: token,
  //         cid: cid,
  //         mcd: login.mcd,
  //         level: login.level,
  //     });
  //     if (result.data.success === 1) {
  //         setRatings(result.data.ratings);
  //     }
  //     else {
  //         // Swal.fire(result.data.msg);
  //         alert(1)
  //     }
  // }

  const load_teacher = async () => {
    let result = await axios.post(configState.api + "/gympass/teacher_resume", {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    });
    if (result.data.success === 1) {
      setTeachers(result.data.teachers);
      setResumes(result.data.resumes);
      setEducations(result.data.educations);
      setCareers(result.data.careers);
      setCertificates(result.data.certificates);
      setRatings(result.data.ratings);
      // setImage('/uploads/resume/' + ('00000000' + result.data.teachers.seq).substr(-8, 8) + '_' + result.data.teachers.tcd + '.jpg');
      console.log(result.data.resumes)
    } else {
      Swal.fire(result.data.msg);
    }
  };

  // useEffect(() => {
  //     if(openCenter === true) {
  //     load_average();
  //     }
  // }, [openCenter])

  useEffect(() => {
    load_teacher();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const copyAction = () => {
    setOpen(true);
  };

  const closeSnack = (e, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const CallEducation = (obj) => {
    const temp = educations.filter(
      (el) => parseInt(el.resume_seq) === JSON.parse(obj.resume_seq)
    );
    return (
      <Box>
        {temp.map((i, idx) => {
          return (
            <Box
              sx={{
                fontSize: "12px",
              }}
              key={idx}
            >
              <Typography
                sx={{ display: "inline-block" }}
                fontWeight="bold"
                fontSize={12}
              >
                {moment(i.grdate).format("YYYY.MM")}
              </Typography>{" "}
              {i.sname} {i.major} {i.degree} {i.state}
            </Box>
          );
        })}
        {temp.length === 0 && (
          <Box sx={{ fontSize: "12px" }}>학력이 등록되지 않았습니다.</Box>
        )}
      </Box>
    );
  };

  const CallCareer = (obj) => {
    const temp = careers.filter(
      (el) => parseInt(el.resume_seq) === JSON.parse(obj.resume_seq)
    );
    return (
      <Box>
        {temp.map((i, idx) => {
          return (
            <Box
              sx={{
                fontSize: "12px",
              }}
              key={idx}
            >
              {i.is_checked === "T" && i.edate === "" ? "현)" : "전)"}{" "}
              {i.company} {i.department} {i.position}
              {/* ({moment(i.sdate).format('YYYY.MM')}~{i.edate === '' ? '' : moment(i.edate).format('YYYY.MM')}) */}
            </Box>
          );
        })}
        {temp.length === 0 && (
          <Box sx={{ fontSize: "12px" }}>경력이 등록되지 않았습니다.</Box>
        )}
      </Box>
    );
  };

  const CallCertificate = (obj) => {
    const temp = certificates.filter(
      (el) => parseInt(el.resume_seq) === JSON.parse(obj.resume_seq)
    );
    return (
      <Box>
        {temp.map((i, idx) => {
          return (
            <Box
              sx={{
                fontSize: "12px",
              }}
              key={idx}
            >
              <Typography
                sx={{ display: "inline-block" }}
                fontWeight="bold"
                fontSize={12}
              >
                {moment(i.date).format("YYYY.MM")}
              </Typography>{" "}
              {i.license} {i.publisher}
            </Box>
          );
        })}
        {temp.length === 0 && (
          <Box sx={{ fontSize: "12px" }}>자격이 등록되지 않습니다.</Box>
        )}
      </Box>
    );
  };

  const CallRatings = (obj) => {
    const temp = ratings.filter((el) => el.tcd === obj.tcd);
    return (
      <Box>
        {temp.map((i, idx) => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                mb: 1,
              }}
              key={idx}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    fontSize: "12px",
                  }}
                >
                  {i.pt_type === "GX"
                    ? "그룹"
                    : i.pt_type === "PT_MANAGER"
                    ? "점장PT"
                    : i.pt_type === "PT_TRAINER"
                    ? "트레이너PT"
                    : ""}
                </Box>
                <Box fontSize="10px" textAlign="center">
                  {parseInt(i.cnt) === 0
                    ? "(평가가 없습니다)"
                    : "(" + i.cnt + "회 평가)"}
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  overflow: "visible",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Rating
                  defaultValue={parseFloat(i.avg)}
                  precision={0.5}
                  sx={{ fontSize: "14pt" }}
                  readOnly
                />
                <Box fontSize="12px" fontWeight="bold">
                  {parseInt(i.cnt) === 0 ? null : i.avg}
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    );
  };

  // console.log(teachers)

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <TabContext value={value}>
        <TabList
          value={value}
          onChange={handleChange}
          sx={{
            "& .MuiTabs-flexContainer": {
              justifyContent: "space-around",
            },
          }}
        >
          <Tab
            value="1"
            label="시설안내"
            sx={{ minWidth: 20, padding: "0 5px" }}
          ></Tab>
          <Tab
            value="2"
            label="강사소개"
            sx={{ minWidth: 20, padding: "0 5px" }}
          ></Tab>
          <Tab
            value="3"
            label="위치안내"
            sx={{ minWidth: 20, padding: "0 5px" }}
          ></Tab>
        </TabList>
        <Divider />
        <TabPanel value="1">
          {center.center_info.map((item, index) => {
            return (
              <Box key={index}>
                {item.youtube === "" ? null : (
                  <iframe
                    width="100%"
                    height="228"
                    style={{ marginBottom: "20px" }}
                    src={item.youtube}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                )}
                <ImageGallery
                  items={item.images}
                  showPlayButton={false}
                  showFullscreenButton={false}
                  showNav={false}
                />
                <Grid container direction="column">
                  <br></br>
                  <Box sx={{ fontWeight: "bold", fontSize: "18px" }}>
                    {center.name}
                  </Box>
                  <Box sx={{ fontSize: "15px" }}>
                    <Box
                      sx={{
                        marginBottom: "15px",
                        display: "flex",
                        alignItem: "center",
                      }}
                      onClick={() => copyAction()}
                    >
                      <CopyToClipboard text={item.address}>
                        <Typography fontSize="14px">{item.address}</Typography>
                      </CopyToClipboard>
                      &nbsp;
                      <ContentCopyIcon fontSize="small" />
                    </Box>
                    <br></br>
                    {item.time}
                  </Box>
                </Grid>
                <Snackbar
                  open={open}
                  autoHideDuration={3000}
                  onClose={closeSnack}
                >
                  <Alert onClose={closeSnack} width="100%">
                    복사 되었습니다
                  </Alert>
                </Snackbar>
              </Box>
            );
          })}
        </TabPanel>
        <ThemeProvider theme={teacherInfo}>
          <TabPanel value="2">
            <Grid
              container
              direction="row"
              width="100%"
              justifyContent="space-around"
            >
              {resumes.map((item, index) => {
                return (
                  <Box
                    sx={{
                      width: "100%",
                    }}
                    key={index}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        width: "100%",
                        mt: 3,
                        mb: 3,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {item.file !== "" && (
                          <Box
                            sx={{
                              width:
                                cid !== "XXXXX" /*줌*/ ? "12vh" : "7rem",
                              height:
                                cid !== "XXXXX" /*줌*/ ? "12vh" : "7rem",
                              marginBottom: "5px",
                              overflow: "hidden",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              backgroundImage: `url(${item.file})`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              borderRadius: "50%",
                            }}
                          ></Box>
                        )}
                        {item.file === "" && (
                          <Box
                            sx={{
                              width:
                                cid !== "XXXXX" /*줌*/ ? "12vh" : "7rem",
                              height:
                                cid !== "XXXXX" /*줌*/ ? "12vh" : "7rem",
                              marginBottom: "5px",
                              overflow: "hidden",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "50%",
                              border: "1px solid black",
                            }}
                          >
                            <Box>
                              이미지가
                              <br></br>
                              없습니다
                            </Box>
                          </Box>
                        )}
                        <CallRatings tcd={item.tcd} />
                      </Box>
                      <Grid container direction="column" width="60%">
                        <Box sx={{ fontSize: "15px", fontWeight: "bold" }}>
                          {item.name} {item.mb_grade}
                        </Box>
                        <Box
                          sx={{ fontSize: "13px", fontWeight: "bold", mt: 1 }}
                        >
                          학력
                        </Box>
                        <CallEducation
                          resume_seq={item.seq + ""}
                        ></CallEducation>
                        <Box
                          sx={{ fontSize: "13px", fontWeight: "bold", mt: 1 }}
                        >
                          경력
                        </Box>
                        <CallCareer resume_seq={item.seq + ""}></CallCareer>
                        <Box
                          sx={{ fontSize: "13px", fontWeight: "bold", mt: 1 }}
                        >
                          자격
                        </Box>
                        <CallCertificate
                          resume_seq={item.seq + ""}
                        ></CallCertificate>
                      </Grid>
                    </Box>
                    <Box
                      sx={{ borderBottom: "1px dashed rgba(0, 0, 0, 0.25)" }}
                    />
                  </Box>
                );
              })}
            </Grid>
          </TabPanel>
        </ThemeProvider>
        <TabPanel value="3">
          <Grid container>
            <CenterMap />
          </Grid>
        </TabPanel>
      </TabContext>
    </Box>
  );
}

export default CenterInfo;
